import React, {useEffect, useState} from 'react';
import {useAuth} from '../contexts/Auth';
import {history} from '../helpers/history';

export const OAuthCallback = () => {
  const {handleCallback} = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code || !state) {
      setError('Missing OAuth parameters.');
      return;
    }

    handleCallback(code, state)
      .then(() => history.push('/'))
      .catch((err) => setError(err.message || 'Authentication failed.'));
  }, [handleCallback]);

  if (error) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div style={{fontSize: 48, marginBottom: 12}}><span role="img" aria-label="error">❌</span></div>
          <h2>Sign-in failed</h2>
          <p style={{color: 'var(--red)'}}>{error}</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => history.push('/login')}
            style={{marginTop: 12}}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{fontSize: 48, marginBottom: 12}}><span role="img" aria-label="loading">⏳</span></div>
        <p>Completing sign-in…</p>
      </div>
    </div>
  );
};
